import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow benign "ResizeObserver loop" errors so CRA's error overlay doesn't block the UI.
const _isResizeObserverErr = (msg) => typeof msg === "string" && msg.includes("ResizeObserver loop");
window.addEventListener("error", (e) => {
  if (_isResizeObserverErr(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  if (_isResizeObserverErr(e.reason?.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
